"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var componentStyle = {
    base: {
        margin: '30px 0 20px',
    },
};
exports.TopicHeader = function (_a) {
    var children = _a.children;
    return (React.createElement("h3", { style: componentStyle.base }, children));
};
exports.TopicHeader.displayName = 'TopicHeader';



//////////////////
// WEBPACK FOOTER
// ./src/docs/common/TopicHeader/TopicHeader.tsx
// module id = 627
// module chunks = 0